import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "ul-img-box"
};
var _hoisted_2 = {
  key: 0
};
var _hoisted_3 = ["src", "onClick"];
var _hoisted_4 = ["onClick"];
var _hoisted_5 = ["src"];
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { Bridge } from '@/utils/bridge';
import { showToast } from 'vant';
import { useI18n } from 'vue-i18n';
import constants, { processUserAgent } from '@/constants';
export default {
  __name: 'ShareBtn',
  props: ['shareConfiguration'],
  emits: ['closeSharePopup'],
  setup(__props, {
    emit
  }) {
    var props = __props;
    var IMAGE_URL = constants.IMAGE_URL,
      _constants$SHARE_MODU = constants.SHARE_MODULE,
      MAX_PIC_NUM = _constants$SHARE_MODU.MAX_PIC_NUM,
      SHARE_TYPE = _constants$SHARE_MODU.SHARE_TYPE,
      BTN_TYPE_FUNC = _constants$SHARE_MODU.BTN_TYPE_FUNC,
      IMG_URL = _constants$SHARE_MODU.IMG_URL;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var store = useStore();
    var ulClass = ref('');
    var canvasRef = ref(null);
    var asinImgList = ref();
    var isLoading = ref(false);
    var html2canvas = null;

    // phone bottom security height
    var distanceFromPhoneBottomStatusBar = computed(() => {
      var _store$state$navigato;
      return (_store$state$navigato = store.state.navigator.agentData.bottom) !== null && _store$state$navigato !== void 0 ? _store$state$navigato : 0;
    });
    var getSelectedPicNumber = selectedPic => {
      var num = store.state.share.picListSelected.findIndex(el => el === selectedPic);
      return num >= 0 ? num + 1 : -1;
    };
    var convertImgUrlToBase64Format = (el, url, outputFormat = '') => {
      return new Promise(resolve => {
        var canvas = el;
        setTimeout(() => {
          var ctx = canvas.getContext('2d');
          var img = new Image();
          img.crossOrigin = 'Anonymous';
          img.src = url;
          img.onload = function () {
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            var dataURL = canvas.toDataURL(outputFormat || 'image/jpg');
            resolve(dataURL);
          };
        }, 300);
      });
    };
    var getImgList = () => {
      var _props$shareConfigura, _props$shareConfigura2, _props$shareConfigura3, _props$shareConfigura4;
      var imgList = props.shareConfiguration.asinInfo.imageUrls.map((el, idx) => {
        var imgInfo = {};
        imgInfo.url = el;
        imgInfo.state = idx === 0;
        return imgInfo;
      });
      var imgUrlDefault = (_props$shareConfigura = props.shareConfiguration) !== null && _props$shareConfigura !== void 0 && (_props$shareConfigura2 = _props$shareConfigura.asinInfo) !== null && _props$shareConfigura2 !== void 0 && _props$shareConfigura2.imageUrls.length ? (_props$shareConfigura3 = props.shareConfiguration) === null || _props$shareConfigura3 === void 0 ? void 0 : (_props$shareConfigura4 = _props$shareConfigura3.asinInfo) === null || _props$shareConfigura4 === void 0 ? void 0 : _props$shareConfigura4.imageUrls[0] : '';
      store.commit('share/setPicListSelected', [imgUrlDefault]);
      return imgList;
    };
    var handleImgSelect = item => {
      var list = [];
      var picListSelected = store.state.share.picListSelected;
      if (picListSelected.length >= MAX_PIC_NUM && !picListSelected.includes(item.url)) {
        showToast({
          message: t('modules.share.SELECT_IMAGES_TO_GENERATE_POST_THRESHOLD'),
          className: 'a-toast'
        });
        return;
      }
      item.state = !item.state;
      list = item.state ? [...picListSelected, item.url] : picListSelected.filter(el => el !== item.url);
      store.commit('share/setPicListSelected', list);
    };
    var getShareImgBase64 = () => {
      var _processUserAgent, _processUserAgent$app;
      /**
       * userAgent:appDeviceScreen/44_34_3.0
       * For this example, the below code will get 'Device Pixel Scale' for the scale.
       */
      var scale = ((_processUserAgent = processUserAgent(navigator.userAgent)) === null || _processUserAgent === void 0 ? void 0 : (_processUserAgent$app = _processUserAgent.appDeviceScreen) === null || _processUserAgent$app === void 0 ? void 0 : _processUserAgent$app.split('_')[2]) || 1.0;
      return new Promise(resolve => {
        var dom = document.querySelector('#poster-share');
        setTimeout(() => {
          html2canvas(dom, {
            useCORS: true,
            scale,
            width: dom.clientWidth,
            height: dom.scrollHeight,
            allowTaint: true
          }).then(canvas => {
            var imgUrl = canvas.toDataURL();
            resolve(imgUrl);
          });
        }, 300);
      });
    };
    var BTN_TYPE = [{
      icon: IMG_URL.WECHAT_URL,
      text: t('modules.share.WECHAT_FRIENDS'),
      eventName: BTN_TYPE_FUNC.shareWechat
    }, {
      icon: IMG_URL.GENERATE_IMAGES_URL,
      text: t('modules.share.GENERATE_IMAGES'),
      eventName: BTN_TYPE_FUNC.generateImages
    }, {
      icon: IMG_URL.SAVE_IMAGES_URL,
      text: t('modules.share.SAVE_PICTURE'),
      eventName: BTN_TYPE_FUNC.saveImages
    }];
    var handleCloseSharePoopup = () => {
      emit('closeSharePopup');
    };
    var handleShareWeChat = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$Bridge$callFnV, hasWeChat, imgUrl, thumbImageBase64;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Bridge.callFnVal('checkWeChatAppHasInstalled');
            case 2:
              _yield$Bridge$callFnV = _context.sent;
              hasWeChat = _yield$Bridge$callFnV.result;
              if (hasWeChat) {
                _context.next = 7;
                break;
              }
              showToast({
                message: t('modules.share.WECHAT_IS_NOT_INSTALLED'),
                className: 'a-toast'
              });
              return _context.abrupt("return");
            case 7:
              imgUrl = props.shareConfiguration.asinInfo.imageUrls[0] || `${IMAGE_URL}assets/image/emptyList.png`;
              _context.next = 10;
              return convertImgUrlToBase64Format(canvasRef.value, imgUrl, 'image/png');
            case 10:
              thumbImageBase64 = _context.sent;
              _context.next = 13;
              return Bridge.callFn('shareData', {
                platform: store.state.share.platform,
                type: SHARE_TYPE.shareLink,
                data: {
                  url: props.shareConfiguration.shareUrl,
                  title: props.shareConfiguration.asinInfo.title,
                  description: t('modules.share.WECHAT_SHARE_TITLE'),
                  thumbImageBase64
                }
              });
            case 13:
              handleCloseSharePoopup();
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function handleShareWeChat() {
        return _ref.apply(this, arguments);
      };
    }();
    var handleGenerateImages = () => {
      var imageUrls = props.shareConfiguration.asinInfo.imageUrls;
      var picListSelected = imageUrls.length ? [imageUrls[0]] : [];
      store.commit('share/setPicListSelected', picListSelected);
      store.commit('share/setShareBtn', [BTN_TYPE[0], BTN_TYPE[2]]);
      store.commit('share/setIsShowPoster', true);
    };
    var handleSaveImages = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var imageBase64, _yield$Bridge$callFnV2, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              isLoading.value = true;
              _context2.next = 3;
              return getShareImgBase64();
            case 3:
              imageBase64 = _context2.sent;
              _context2.next = 6;
              return Bridge.callFnVal('saveImageToAlbum', {
                imageBase64
              });
            case 6:
              _yield$Bridge$callFnV2 = _context2.sent;
              result = _yield$Bridge$callFnV2.result;
              isLoading.value = false;
              if (result) {
                _context2.next = 11;
                break;
              }
              return _context2.abrupt("return");
            case 11:
              showToast({
                message: t('modules.share.GENERATE_IMAGES_SUCCEED'),
                className: 'a-toast'
              });
              handleCloseSharePoopup();
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function handleSaveImages() {
        return _ref2.apply(this, arguments);
      };
    }();
    var handleBtn = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(type) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = type;
              _context3.next = _context3.t0 === BTN_TYPE_FUNC.shareWechat ? 3 : _context3.t0 === BTN_TYPE_FUNC.generateImages ? 6 : _context3.t0 === BTN_TYPE_FUNC.saveImages ? 8 : 11;
              break;
            case 3:
              _context3.next = 5;
              return handleShareWeChat();
            case 5:
              return _context3.abrupt("break", 14);
            case 6:
              handleGenerateImages();
              return _context3.abrupt("break", 14);
            case 8:
              _context3.next = 10;
              return handleSaveImages();
            case 10:
              return _context3.abrupt("break", 14);
            case 11:
              _context3.next = 13;
              return handleShareWeChat();
            case 13:
              return _context3.abrupt("break", 14);
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function handleBtn(_x) {
        return _ref3.apply(this, arguments);
      };
    }();
    onMounted(() => {
      var _props$shareConfigura5;
      if (((_props$shareConfigura5 = props.shareConfiguration) === null || _props$shareConfigura5 === void 0 ? void 0 : _props$shareConfigura5.type) === SHARE_TYPE.shareLink) {
        store.commit('share/setShareBtn', [BTN_TYPE[0]]);
        ulClass.value = 'ulBtn';
      } else {
        store.commit('share/setShareBtn', [BTN_TYPE[0], BTN_TYPE[1]]);
      }
      import('html2canvas').then(plugin => {
        html2canvas = plugin['default'];
      });
      asinImgList.value = getImgList();
    });
    return (_ctx, _cache) => {
      var _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "container-share",
        style: _normalizeStyle({
          paddingBottom: `${distanceFromPhoneBottomStatusBar.value}px`
        })
      }, [_createElementVNode("canvas", {
        ref_key: "canvasRef",
        ref: canvasRef,
        style: {
          "display": "none"
        }
      }, null, 512), _unref(store).state.share.isShowPoster ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(asinImgList.value, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index
        }, [getSelectedPicNumber(item.url) !== -1 ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(getSelectedPicNumber(item.url)), 1)) : _createCommentVNode("", true), _createElementVNode("img", {
          src: item.url,
          class: _normalizeClass(["img-border", {
            'img-no-border': !item.state
          }]),
          onClick: $event => handleImgSelect(item)
        }, null, 10, _hoisted_3)]);
      }), 128))])) : _createCommentVNode("", true), _createElementVNode("ul", {
        class: _normalizeClass([ulClass.value, "ul-btn-box"])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.share.shareBtn.btnList, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          onClick: $event => handleBtn(item.eventName)
        }, [_createElementVNode("img", {
          src: item.icon
        }, null, 8, _hoisted_5), _createElementVNode("p", null, _toDisplayString(item.text), 1)], 8, _hoisted_4);
      }), 128))], 2), _createElementVNode("div", {
        class: "btn-cancel",
        onClick: handleCloseSharePoopup
      }, _toDisplayString(_ctx.$t('modules.share.CANCEL_ACTION')), 1)], 4)), [[_directive_loading, isLoading.value]]);
    };
  }
};